<template>
  <div class="app" data-app>
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand eb-navbar-brand" to="#">
        <span class="navbar-brand-full sidemenuLogo"
          ><img src="img/calonex_logo.png"
        /></span>
        <span class="navbar-brand-minimized"
          ><img src="img/calonex_small.png"
        /></span>
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <!-- <span>
        <Breadcrumb :list="list" />
      </span> -->
      <b-navbar-nav class="d-md-down-none justify-content-end">
        
        <b-nav-item>
          <headerSearch></headerSearch>
        </b-nav-item>
        <b-nav-item>
          <notificationbell></notificationbell>
        </b-nav-item>
        <b-nav-item>
          <headerSetting></headerSetting>
        </b-nav-item>
        <b-nav-item>
          <DefaultHeaderDropdownAccnt />
        </b-nav-item>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body" v-if="$currentUserData">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarMinimizer />
        <SidebarForm />
        <SidebarNav :navItems="safeItems"></SidebarNav>
        <SidebarFooter />
      </AppSidebar>
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6">
            2018 - 2019 ©
            <a href>Trigital</a> - Nipige.com
          </div>
          <div class="col-md-6">
            <div class="text-md-right footer-links d-none d-md-block">
              <a href="#" class="mr-2">About</a>
              <a href="#" class="mr-2">Support</a>
              <a href="#" class="mr-2">Contact Us</a>
            </div>
          </div>
        </div>
      </div>
    </TheFooter>
    <orderModal v-if="isShowModal"></orderModal>
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@/components";
import orderModal from "@/components/OrderModal/OrderModal.vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import { mapActions } from "vuex";
import headerSearch from "@/components/Header/HeaderSearch.vue";
import headerSetting from "@/components/Header/HeaderSetting.vue";
import notificationbell from "@/components/Header/headerbell.vue";
export default {
  name: "DefaultContainer",
  components: {
    orderModal,
    notificationbell,
    headerSearch,
    headerSetting,
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },
  data() {
    return {
      nav: nav.items,
      search: "",
      newMessageData: null,
      modalShow: false,
    };
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    currentOrderData() {
      return this.$store.getters["notification/GetCurrentOrderDetails"];
    },
    isShowModal() {
      return this.$store.getters["notification/GetNotificationModalState"];
    },
    searchText: {
      get: function () {
        return this.search;
      },
      set: function (newVal) {
        this.$store.dispatch("product/search", newVal);
        this.search = newVal;
      },
    },
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
    safeItems: {
      get() {
        if (this.$currentUserData) {
          let permissions = {};
          const isTruthy = (r) => r !== null && r !== undefined;
          const isArray = (r) => Array.isArray(r) && r.length > 0;
          permissions = { ...this.$currentUserData.permissions };
          let allowedItems = [];
          allowedItems = this.nav
            .map((route) => {
              const { auth } = route;
              if (!auth) return route;
              // ==============================
              // Check all required permissions
              // ==============================
              const { required } = auth;
              if (isArray(required)) {
                for (let i = 0; i < required.length; i++) {
                  const permission = required[i];
                  if (!permissions[permission]) {
                    return null;
                  }
                }
              }
              // ==============================
              // Check all optional permissions
              // ==============================
              const { oneOf } = auth;
              if (isArray(oneOf)) {
                const found = oneOf.find((perm) => isTruthy(permissions[perm]));
                if (
                  !isTruthy(found) ||
                  (this.$userRole === "Admin" && found === "CREATE_ITEM") ||
                  (this.$userRole === "Partner" && found === "LIST_CATALOG")
                ) {
                  return null;
                }
              }
              // check for child permission for setup
              if (route.children && route.children.length > 0) {
                let filteredChild = route.children.filter((obj) =>
                  obj.auth.oneOf.some((perm) =>
                    permissions.hasOwnProperty(perm)
                  )
                );
                route.children = [].concat(filteredChild);
              }
              return route;
            })
            .filter(isTruthy);
          return allowedItems;
        } else {
          return [];
        }
      },
    },
  },
  methods: {
    ...mapActions({
      getPreference: "tenant/getTenantPreferences",
    }),
    socketReconnect() {
      if (this.$currentUserData) {
        let userdata = this.$currentUserData;
        let object = {
          uid: userdata._id,
        };
        // $socket is socket.io-client instance
        this.$socket.emit("adduser", object);
        this.$socket.emit("getunread", object);
      }
      this.sockets.subscribe("mymessage", (data) => {
        if (Array.isArray(data)) {
          console.log("notificationArr", data);
          this.$store.dispatch("notification/setAllNotifications", data);
        } else {
          console.log("new message", data);
          if (
            data.message.type === "order-request" ||
            data.message.type === "manufacturer-order-request"
          ) {
            this.$store.dispatch("notification/openNotificationModal", true);
            this.$store.dispatch("notification/setNewOrdersNotification", data);
            let orderLink =
              this.$store.getters["notification/GetNewOrderNotification"];
            console.log(orderLink["message"]["orderDetailsLink"]);
            this.$store.dispatch(
              "notification/getOrderDetails",
              orderLink["message"]["orderDetailsLink"]
            );
          }
        }
      });
    },
  },
  mounted() {
    if (this.$currentUserData) {
      this.initSocket();
      let userdata = this.$currentUserData;
      let object = {
        uid: userdata._id,
      };
      if (this.userRole === "Partner") {
        this.getPreference(userdata.tenant);
      } else if (this.userRole === "Tenant") {
        this.getPreference(userdata._id);
      }
      // $socket is socket.io-client instance
      this.$socket.emit("adduser", object);
      this.$socket.emit("getunread", object);
      console.log(this.sockets, this.$socket);
      if (this.sockets) {
        this.sockets.subscribe("mymessage", (data) => {
          if (Array.isArray(data)) {
            console.log("notificationArr", data);
            this.$store.dispatch("notification/setAllNotifications", data);
          } else {
            console.log("new message", data);
            if (
              data.message.type === "order-request" ||
              data.message.type === "manufacturer-order-request"
            ) {
              this.$store.dispatch("notification/openNotificationModal", true);
              this.$store.dispatch(
                "notification/setNewOrdersNotification",
                data
              );
              let orderLink =
                this.$store.getters["notification/GetNewOrderNotification"];
              console.log(orderLink["message"]["orderDetailsLink"]);
              this.$store.dispatch(
                "notification/getOrderDetails",
                orderLink["message"]["orderDetailsLink"]
              );
            }
          }
        });
      }
    }
  },
  sockets: {
    connect: function () {
      console.log("Socket connected");
    },
    reconnect: function () {
      console.log("reconnected socket");
      this.$socket.io.reconnect();
      this.socketReconnect();
    },
    disconnect: () => {
      console.log("Disconnected!");
    },
  },
};
</script>

<style>
.eb-navbar {
  background: linear-gradient(135deg, #8b76de 0, #8178e7 60%);
  width: 215px;
  margin-left: -17px;
  height: 71px;
  margin-top: -15px;
}
.eb-navbar-brand {
  margin-left: -14px !important;
  margin-top: -7px !important;
}
.sidemenuLogo img {
  width: 130px;
}
@media (min-width: 992px) {
  .brand-minimized .app-header .navbar-brand {
    width: 50px !important;
    background-color: transparent;
    transition: 0.2s;
    transition-timing-function: linear;
  }
}
@media screen and (max-width: 992px) {
  .eb-navbar-brand {
    display: none !important;
  }
}
@media only screen and (max-width: 992px) {
  .app-search {
    display: block !important;
  }
}

@media (max-width: 575.98px) {
  .sidebar-show .main::before,
  .aside-menu-show .main::before {
    background: none !important;
  }
}
@media (min-width: 575.98px) {
  .header-fixed .app-header {
    position: fixed;
  }
}
@media (min-width: 200.98px) {
  .header-fixed .app-header {
    position: fixed;
  }
}
</style>
